<!--
 * @Author: your name
 * @Date: 2020-09-22 16:44:05
 * @LastEditTime: 2020-10-14 12:11:33
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /x-product-workspace/packages/xdap-h5/src/pages/form/setting-message-remind/setting-message-remind.vue
-->
<template>
  <div class="setting-message-remind">
    <div class="form-item" @click="openRemindType">
      <x-proxy-form-item label="提醒类型">
        <cube-select
          ref="remindTypeSelectRef"
          v-model="formData.remindType"
          :options="remindTypePersonOptions"
          @change="handleRemindTypeChange"
        >
        </cube-select>
      </x-proxy-form-item>
      <div class="form-select-suffix full-height">
        <x-svg-icon name="x-lib-arrow-right"></x-svg-icon>
      </div>
    </div>

    <template v-if="formData.remindType === 'REMIND_APPOINT'">
      <div class="form-item" @click="openRemindTime">
        <x-proxy-form-item label="提醒时间">
          <cube-input
            v-model="formData.remindTime.remindDate"
            class="form-input"
            :readonly="true"
            placeholder="请选择提醒时间"
          ></cube-input>
        </x-proxy-form-item>
        <div class="form-select-suffix full-height">
          <x-svg-icon name="x-lib-arrow-right"></x-svg-icon>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="form-item" @click="openRemindField">
        <x-proxy-form-item label="提醒字段">
          <cube-select
            ref="remindFieldSelectRef"
            v-model="formData.remindTime.startDateSet.dateUuid"
            :options="dateComps"
          >
          </cube-select>
        </x-proxy-form-item>
        <div class="form-select-suffix full-height">
          <x-svg-icon name="x-lib-arrow-right"></x-svg-icon>
        </div>
      </div>

      <div class="form-item" @click="openRemindWhen">
        <x-proxy-form-item label="提醒时刻">
          <cube-select
            ref="remindWhenSelectRef"
            v-model="formData.remindTime.startDateSet.remindWhen"
            :options="remindWhen"
          >
          </cube-select>
        </x-proxy-form-item>
        <div class="form-select-suffix full-height">
          <x-svg-icon name="x-lib-arrow-right"></x-svg-icon>
        </div>
      </div>

      <div v-if="formData.remindTime.startDateSet.remindWhen !== 'TODAY'" class="form-item">
        <x-proxy-form-item label="天数">
          <cube-input
            v-model="formData.remindTime.startDateSet.remindDay"
            class="form-input"
            placeholder="请输入天数"
            type="number"
          ></cube-input>
        </x-proxy-form-item>
      </div>

      <div class="form-item" @click="openFormFieldRemindTimePicker">
        <x-proxy-form-item label="提醒时间">
          <cube-input
            v-model="formData.remindTime.startDateSet.remindTime"
            class="form-input"
            :readonly="true"
            placeholder="请选择提醒时间"
          ></cube-input>
        </x-proxy-form-item>
        <div class="form-select-suffix full-height">
          <x-svg-icon name="x-lib-arrow-right"></x-svg-icon>
        </div>
      </div>
    </template>

    <div class="form-item">
      <x-proxy-form-item label="提醒方式">
        <cube-checkbox-group v-model="formData.remindWay">
          <template v-for="(option, index) in remindWayOptions">
            <cube-checkbox :key="index" :option="{ value: option.value }">
              <div class="checkbox-box">
                <x-svg-icon
                  v-if="formData.remindWay && formData.remindWay.includes(option.value)"
                  class="checkbox-svg-ui active"
                  name="x-lib-checkbox-active"
                ></x-svg-icon>
                <x-svg-icon v-else class="checkbox-svg-ui" name="x-lib-checkbox"></x-svg-icon>
                <div class="checkbox-tag">
                  <span>{{ option.label }}</span>
                </div>
              </div>
            </cube-checkbox>
          </template>
        </cube-checkbox-group>
      </x-proxy-form-item>
    </div>

    <div class="form-item">
      <x-proxy-form-item label="提醒内容">
        <cube-textarea
          v-model="formData.reminderContain[0].containName"
          :indicator="true"
          :maxlength="2000"
          placeholder="请输入提醒内容"
        ></cube-textarea>
      </x-proxy-form-item>
    </div>

    <div class="form-item sure-btn">
      <cube-button @click="handleSave">
        确定
      </cube-button>
    </div>
  </div>
</template>

<script>
import remindConfig from './model.config'
import { mapState } from 'vuex'
import apis from '@/api'
import excludeComponentTypes from '@/vender/exclude-component-type'

export default {
  name: 'SettingMessageRemind',
  data() {
    return {
      ...remindConfig,
      validateInfo: {},
      formData: {
        remindType: 'REMIND_APPOINT',
        remindTime: {},
        remindWay: [],
        reminderContain: [{ containType: 'TEXT', containName: '' }]
      },
      remindTypePersonOptions: [],
      remindWayOptions: [
        { value: 'EMAIL', label: '邮件' },
        { value: 'SMS', label: '短信' },
        { value: 'WECHAT', label: '微信' }
      ],
      allComps: []
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.authModule.userInfo
    }),
    dateComps() {
      let arr = []
      arr = [...this.allComps.filter((item) => !excludeComponentTypes.MESSAGE_REMIND_SYSTEM_EXCLUDE.includes(item.componentType))].map((item) => {
        return {
          ...item,
          text: item.label,
          value: item.uuid
        }
      })
      return arr
    }
  },
  created() {
    this.remindTypePersonOptions = remindConfig.remindTypePersonOptions.map((item) => {
      item.text = item.label
      return item
    })

    this.remindWhen = remindConfig.remindWhen.map((item) => {
      item.text = item.label
      return item
    })

    this.queryListComponents(this.$route.query.formId)

    if (this.$route.query.scheduleId) {
      this.queryMessageRemindDetail(this.$route.query.scheduleId)
    } else {
      this.formData.remindWay = ['EMAIL']
    }
  },
  methods: {
    queryListComponents(formId) {
      const request = { ...apis.COMPONENT.QUERY_LIST_COMPONENTS_SORT }
      request.params = {
        formId
      }
      this.$request(request)
        .asyncThen(
          (resp) => {
            const sourceComps = this.$lodash
              .cloneDeep(resp.data.businessComponents)
              .filter(
                (item) => !excludeComponentTypes.MESSAGE_REMIND_BUSINESS_EXCLUDE.includes(item.componentType)
              )
            const systemComps = this.$lodash
              .cloneDeep(resp.data.systemComponents)
              .filter((item) => !excludeComponentTypes.MESSAGE_REMIND_SYSTEM_EXCLUDE.includes(item.componentType))
            this.allComps = [...sourceComps, ...systemComps]
          },
          (error) => {
            console.error(error)
          }
        )
        .asyncErrorCatch((error) => {
          console.error(error)
        })
    },
    queryMessageRemindDetail(scheduleId) {
      this.$loading.show()
      const request = { ...apis.MESSAGE_REMIND.QUERY_PRESONAL_MESSAGE_REMIND_DETAIL }
      request.params = { scheduleId: scheduleId }
      this.$request(request)
        .asyncThen(
          (resp) => {
            this.formData = resp.data
            if (!this.formData.reminderContain) {
              this.formData.reminderContain = [{ containType: 'TEXT', containName: '' }]
            } else {
              const reminderContain = { containType: 'TEXT', containName: '' }
              this.formData.reminderContain.forEach((contain) => {
                reminderContain.containName += contain.containName
              })
              this.formData.reminderContain = [reminderContain]
            }
            this.$loading.hide()
          },
          (err) => {
            this.$loading.hide()
            console.error(err)
          }
        )
        .asyncErrorCatch((err) => {
          this.$loading.hide()
          console.error(err)
        })
    },
    openRemindType() {
      this.$refs.remindTypeSelectRef.showPicker()
    },
    openRemindField() {
      this.$refs.remindFieldSelectRef.showPicker()
    },
    openRemindWhen() {
      this.$refs.remindWhenSelectRef.showPicker()
    },
    openRemindTime() {
      this.$createDatePicker({
        title: '请选择提醒时间',
        min: new Date(1970, 0, 1, 0, 0, 0),
        max: new Date(new Date().getFullYear() + 100, 11, 31, 23, 59, 59),
        value: this.formData.remindTime && this.formData.remindTime.remindDate ? this.$dayjs(this.formData.remindTime.remindDate).toDate() : new Date(),
        format: {
          year: 'YYYY',
          month: 'MM',
          date: 'DD',
          hour: 'hh',
          minute: 'mm',
          second: 'ss'
        },
        columnCount: 6,
        onSelect: (date, selectedVal, selectedText) => {
          if (!this.formData.remindTime) {
            this.formData.remindTime = {}
          }
          this.$set(this.formData, 'remindTime', {
            remindDate: selectedText.slice(0, 3).join('-') + ' ' + selectedText.slice(3).join(':')
          })
        },
        onCancel: () => {}
      }).show()
    },
    openFormFieldRemindTimePicker() {
      let value
      if (this.formData.remindTime.startDateSet.remindTime) {
        const tempArr = this.formData.remindTime.startDateSet.remindTime.split(':')
        value = this.$dayjs().set('hour', tempArr[0]).set('minute', tempArr[1]).toDate()
      } else {
        value = new Date()
      }
      this.$createDatePicker({
        title: '请选择提醒时间',
        value: value,
        min: [0, 0],
        max: [23, 59],
        startColumn: 'hour',
        columnCount: 2,
        onSelect: (date, selectedVal, selectedText) => {
          this.formData.remindTime.startDateSet.remindTime = selectedText.join(':')
        },
        onCancel: () => {}
      }).show()
    },
    handleSave() {
      // 校验
      if (!this.formData.remindType) {
        this.$message({
          message: '提醒类型不能为空',
          type: 'error'
        })
        return
      }

      if (this.formData.remindType === 'REMIND_APPOINT') {
        if (!this.formData.remindTime || !this.formData.remindTime.remindDate) {
          this.$message({
            message: '提醒时间不能为空',
            type: 'error'
          })
          return
        }
      } else {
        if (this.formData.remindTime) {
          if (!this.formData.remindTime.startDateSet.dateUuid) {
            this.$message({
              message: '提醒字段不能为空',
              type: 'error'
            })
            return
          }
          if (!this.formData.remindTime.startDateSet.remindWhen) {
            this.$message({
              message: '提醒时刻不能为空',
              type: 'error'
            })
            return
          } else {
            if (this.formData.remindTime.startDateSet.remindWhen !== 'TODAY') {
              if (!this.formData.remindTime.startDateSet.remindDay) {
                this.$message({
                  message: '天数不能为空',
                  type: 'error'
                })
                return
              }
            }
          }
          if (!this.formData.remindTime.startDateSet.remindTime) {
            this.$message({
              message: '提醒时间不能为空',
              type: 'error'
            })
            return
          }
        }
      }

      if (!this.formData.remindWay || this.formData.remindWay.length === 0) {
        this.$message({
          message: '提醒方式不能为空',
          type: 'error'
        })
        return
      }

      if (!this.formData.reminderContain[0] || !this.formData.reminderContain[0].containName) {
        this.$message({
          message: '提醒内容不能为空',
          type: 'error'
        })
        return
      }

      // 赋值
      this.formData.remindObject = [{ objectType: 'USER', objectId: this.userInfo.id }]

      // 保存
      const request = { ...apis.MESSAGE_REMIND.SAVE_PERSONAL_MESSAGE_REMIND }
      request.params = {
        appId: this.$route.query.appId,
        documentId: this.$route.query.documentId,
        formId: this.$route.query.formId,
        groupConditionList: [],
        menuId: this.$route.query.menuId,
        ...this.formData,
        ruleText: '',
        status: 'ENABLE'
      }
      this.$request(request)
        .asyncThen(
          (resp) => {
            this.$router.go(-1)
          },
          (error) => {
            console.error(error)
          }
        )
        .asyncErrorCatch((error) => {
          console.error(error)
        })
    },
    handleRemindTypeChange(e) {
      if (e === 'REMIND_APPOINT') {
        this.$set(this.formData, 'remindTime', {
          remindDate: ''
        })
      } else if (e === 'REMIND_FORM_CODE_PERSON') {
        this.$set(this.formData, 'remindTime', {
          startDateSet: { dateUuid: null, remindTime: null, remindWhen: null, timeType: 'ONLY_DATE' }
        })
      }
    }
  }
}
</script>

<style lang="scss">
.setting-message-remind {
  padding-top: 0.571rem;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  box-sizing: border-box;
  background-color: $--app-body-bgColor;

  .form-item {
    position: relative;
    &.sure-btn {
      padding: 1rem 1.14rem;
      .cube-btn {
        height: 2.857rem;
        background-color: $--app-primary-color;
      }
    }
    .form-select-suffix {
      position: absolute;
      top: 0;
      right: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 3.43rem;
      height: calc(100% - 1.71rem);
      color: $--app-notice-color;
      &.full-height {
        height: 100%;
      }
    }
    .content-wrapper {
      .cube-select {
        padding: 0;
        color: $--app-base-font-color;
        font-size: 1rem;
        &::after {
          border: 0;
        }
        .cube-select-icon {
          display: none;
        }
      }

      .cube-checkbox-group {
        &::before {
          border-top: 0 !important;
        }
        .cube-checkbox {
          padding: 0;
          height: 2.857rem;
          padding-left: 2.286rem;
          box-sizing: border-box;

          .cube-checkbox-label {
            width: 100%;
            margin-left: -2.286rem;
          }

          .cube-checkbox-ui {
            display: none;
          }
          .checkbox-box {
            display: flex;
            height: 2.857rem;
            align-items: center;
            width: calc(100% - 1.571rem);
            .checkbox-svg-ui {
              display: flex;
              align-items: center;
              color: $--app-notice-color;
              margin-left: -0.214rem;
              &.active {
                color: $--app-primary-color;
              }
            }
            .checkbox-tag {
              height: 1.714rem;
              display: flex;
              align-items: center;
              padding: 0 0.786rem;
              margin-left: 0.715rem;
              border-radius: 1.714rem;
              max-width: 100%;

              span {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                width: 100%;
                line-height: 1;
                display: inline-block;
              }
            }
          }
        }
      }

      .cube-textarea-wrapper {
        min-height: 5.714286rem !important;
        &::after {
          border: 0 !important;
        }
        .cube-textarea {
          padding: 0;
        }
        .cube-textarea-indicator {
          display: inline-block !important;
        }
      }
    }
  }
}
</style>
